import { ClientLogSearchRequest } from 'api/request/ClientLogSearchRequest';
import { ClientSearchRequest } from 'api/request/ClientSearchRequest';
import { ConclusionSearchRequest } from 'api/request/ConclusionSearchRequest';
import { ControllerSearchRequest } from 'api/request/ControllerSearchRequest';
import { CustomerSearchRequest } from 'api/request/CustomerSearchRequest';
import { GatewaySearchRequest } from 'api/request/GatewaySearchRequest';
import { InquirySearchRequest } from 'api/request/InquirySearchRequest';
import { LogSearchRequest } from 'api/request/LogSearchRequest';
import { NetworkSearchRequest } from 'api/request/NetworkSearchRequest';
import { NoticeSearchRequest } from 'api/request/NoticeSearchRequest';
import { SensorGraphSearchRequest } from 'api/request/SensorGraphSearchRequest';
import { SensorSearchRequest } from 'api/request/SensorSearchRequest';
import { UserSearchRequest } from 'api/request/UserSearchRequest';

export const dashboardKeys = {
  all: ['dashboard'] as const,
  home: (id: string) => ['dashboard', 'home', id] as const,
  status: (id: number) => [...dashboardKeys.all, 'status', id] as const,
  deviceList: (id: number) => [...dashboardKeys.all, 'device', 'list', id] as const,
  details: () => [...dashboardKeys.all, 'detail'] as const,
  detail: (id: number) => [...dashboardKeys.details(), id] as const,
};

export const conclusionKeys = {
  all: ['conclusions'] as const,
  list: (filters: ConclusionSearchRequest) =>
    [
      'conclusions',
      'list',
      { page: filters.page, count: filters.count, customerId: filters.customerId },
    ] as const,
  details: () => [...conclusionKeys.all, 'detail'] as const,
  detail: (id: number) => [...conclusionKeys.details(), id] as const,
};

export const statusBoardKeys = {
  all: ['statusBoardKeys'] as const,
  info: (customerId: number) =>
    [
      'statusBoardKeys',
      { customerId },
    ] as const,
};


export const logKeys = {
  all: ['log'] as const,
  list: (filters: LogSearchRequest) =>
    [
      'log',
      'list',
      {
        page: filters.page,
        count: filters.count,
        lockerId: filters.lockerId,
        userId: filters.userId,
        id: filters.id,
        customerId: filters.customerId
      },
    ] as const,
  alarmList: (filters: LogSearchRequest) => ['alarm', 'list', { page: filters.page, count: filters.count }]
};

export const lockerLogKeys = {
  all: ['lockerLogs'] as const,
  list: (filters: LogSearchRequest) =>
    [
      'lockerLogs',
      'list',
      { page: filters.page, count: filters.count },
    ] as const,
};

export const userKeys = {
  all: ['userKeys'] as const,
  list: (filters: UserSearchRequest) =>
    ['users', 'list', { page: filters.page, count: filters.count, customerId: filters.customerId }] as const,
  details: () => [...userKeys.all, 'detail'] as const,
  detail: (id: number) => [...userKeys.details(), id] as const,
  history: (req: LogSearchRequest) => [...userKeys.all, 'history', { page: req.page, count: req.count }] as const,
  permissionUserList: () => [...userKeys.all, 'permissionUser', 'list'] as const,
  info: ['userKeys', 'mypage'] as const,
  authCheck: ['userKeys', 'mypage', 'auth-check'] as const
};

export const userAuthKeys = {
  all: ['userAuthKeys'] as const,
  details: () => [...userAuthKeys.all, 'detail'] as const,
  detail: (id: number) => [...userAuthKeys.details(), id] as const,
};

export const userPermissionKeys = {
  all: ['userPermissionKeys'] as const,
  list: (userId: number) =>
    ['userPermission', 'list', { userId }] as const,
};

export const userLogKeys = {
  all: ['userLogs'] as const,
  list: (filters: LogSearchRequest) =>
    ['userLogs', 'list', { page: filters.page, count: filters.count }] as const,
};

export const customerKeys = {
  all: ['customerKeys'] as const,
  list: (filters: CustomerSearchRequest) =>
    ['customers', 'list', { page: filters.page, count: filters.count }] as const,
  logList: (filters: LogSearchRequest) =>
    ['customers', 'list', 'log', { page: filters.page, count: filters.count, id: filters.id }] as const,
  details: () => [...customerKeys.all, 'detail'] as const,
  detail: (id: number) => [...customerKeys.details(), id] as const,
};

export const adminKeys = {
  all: ['adminKeys'] as const,
  list: (filters: UserSearchRequest) =>
    ['admins', 'list', { page: filters.page, count: filters.count }] as const,
  details: () => [...adminKeys.all, 'detail'] as const,
  detail: (id: number) => [...adminKeys.details(), id] as const,
};

export const inquiryKeys = {
  all: ['inquiry'] as const,
  list: (filters: InquirySearchRequest) =>
    ['inquiry', 'list', { page: filters.page, count: filters.count }] as const,
  details: () => [...inquiryKeys.all, 'detail'] as const,
  detail: (id: number) => [...inquiryKeys.details(), id] as const,
};

export const noticeKeys = {
  all: ['notice'] as const,
  list: (filters: NoticeSearchRequest) =>
    ['notice', 'list', { page: filters.page, count: filters.count }] as const,
  details: () => [...noticeKeys.all, 'detail'] as const,
  detail: (id: number) => [...noticeKeys.details(), id] as const,
};

export const userInfoKeys = {
  all: ['useInfos'] as const,
  details: () => [...userInfoKeys.all, 'detail'] as const,
  detail: (id: number) => [...userInfoKeys.details(), id] as const,
};

export const gatewayKeys = {
  all: ['gateway'] as const,
  list: (filters: GatewaySearchRequest) =>
    ['gateway', 'list', { customerId: filters.customerId }] as const,
  details: () => [...gatewayKeys.all, 'detail'] as const,
  detail: (id: number) => [...gatewayKeys.details(), id] as const,
};

export const clientKeys = {
  all: ['client'] as const,
  list: (filters: ClientSearchRequest) =>
    ['client', 'list', { page: filters.page, count: filters.count, gatewayId: filters.gatewayId, type: filters.typeDiv }] as const,
  logList: (filters: ClientLogSearchRequest) => ['client', 'logList', { page: filters.page, count: filters.count }] as const,
  details: () => [...clientKeys.all, 'detail'] as const,
  detail: (id: number) => [...clientKeys.details(), id] as const,
};
export const groupKeys = {
  all: ['group'] as const,
  list: (id: number) => ['group', id] as const,
  details: () => [...groupKeys.all, 'detail'] as const,
  detail: (id: number) => [...groupKeys.details(), id] as const,
};
export const networkKeys = {
  all: ['network'] as const,
  list: (filters: NetworkSearchRequest) =>
    ['network', 'list', { page: filters.page, count: filters.count }] as const,
};
export const networkLogKeys = {
  all: ['networkLog'] as const,
  list: (filters: NetworkSearchRequest) =>
    ['networkLog', 'list', { page: filters.page, count: filters.count }] as const,
};
export const sensorKeys = {
  all: ['sensor'] as const,
  list: (filters: SensorSearchRequest) =>
    ['sensor', 'list', { adaptYn: filters.adaptYn }] as const,
  details: () => [...sensorKeys.all, 'detail'] as const,
  detail: (id: number) => [...sensorKeys.details(), id] as const,
  graph: (req: SensorGraphSearchRequest) => [...sensorKeys.details(), { ...req }] as const,
  clientList: (gatewayId: string) => ['client', 'sensor', 'list', { gatewayId }] as const,
};
export const deactivateSensorKeys = {
  all: ['deactivateSensor'] as const,
  list: (filters: SensorSearchRequest) =>
    ['deactivateSensor', 'list', { adaptYn: filters.adaptYn }] as const,
};

export const clientLogKeys = {
  all: ['clientLog'] as const,
  list: (filters: ClientLogSearchRequest) =>
    ['clientLog', 'list', { page: filters.page, count: filters.count }] as const,
};

export const controllerKeys = {
  all: ['controller'] as const,
  list: (filters: ControllerSearchRequest) =>
    ['controller', 'list', { adaptYn: filters.adaptYn, activate: filters.activate, gatewayId: filters.gatewayId }] as const,
  details: () => [...controllerKeys.all, 'detail'] as const,
  detail: (id: number) => [...controllerKeys.details(), id] as const,
};